var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiImageMessageMobIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3457 8.93884C3.26216 9.31316 3.63484 9.68584 4.00916 11.6023C4.01931 11.6537 4.093 11.6537 4.10315 11.6023C4.47747 9.68584 4.85015 9.31316 6.76661 8.93884C6.81803 8.92868 6.81803 8.855 6.76661 8.84485C4.85015 8.47053 4.47747 8.09785 4.10315 6.18138C4.093 6.12997 4.01931 6.12997 4.00916 6.18138C3.63484 8.09785 3.26216 8.47053 1.3457 8.84485C1.29428 8.855 1.29428 8.92868 1.3457 8.93884Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.190086 4.74353C1.17288 4.93511 1.36249 5.12473 1.55408 6.10752C1.55899 6.13307 1.59534 6.13307 1.60025 6.10752C1.79183 5.12473 1.98145 4.93511 2.96424 4.74353C2.98978 4.73862 2.98978 4.70227 2.96424 4.69736C1.98145 4.50578 1.79183 4.31616 1.60025 3.33337C1.59534 3.30782 1.55899 3.30782 1.55408 3.33337C1.36249 4.31616 1.17288 4.50578 0.190086 4.69736C0.164541 4.70227 0.164541 4.73862 0.190086 4.74353Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.69316 3.79109C6.20205 4.29346 6.73291 4.82431 7.23528 7.3332C7.2546 7.42981 7.39247 7.42981 7.41179 7.3332C7.91416 4.82431 8.44502 4.29346 10.9539 3.79109C11.0505 3.77177 11.0505 3.63389 10.9539 3.61457C8.44502 3.11221 7.91416 2.58135 7.41179 0.0724568C7.39247 -0.0241523 7.2546 -0.0241523 7.23528 0.0724568C6.73291 2.58135 6.20205 3.11221 3.69316 3.61457C3.59655 3.63389 3.59655 3.77177 3.69316 3.79109Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiImageMessageMobIcon);
export default __webpack_public_path__ + "static/media/ai-image-message-mob-icon.b1a77036.svg";
export { ForwardRef as ReactComponent };